import { EmptyState } from "@/components/v2/empty-state";

interface ListErrorStateProps {
  entityLabel: string;
  onRetry?: () => void;
}

export function ListErrorState({ entityLabel, onRetry }: ListErrorStateProps) {
  return (
    <EmptyState
      title={`Couldn't load ${entityLabel}`}
      description="Something went wrong fetching this list. Retry, or refresh the page if the issue persists."
      action={onRetry ? { label: "Retry", onClick: onRetry } : undefined}
    />
  );
}
